// extracted by mini-css-extract-plugin
export default {"account_subscriptions":"accounts-edit_account_subscriptions__0hYTb"};